/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Tue May 02 2023
 **/

export const EventID = {
	SHOW_TOAST: "SHOW_TOAST",
	EXEC_UNITY_PLAYER: "EXEC_UNITY_PLAYER",
	SLEEP_UNITY_PLAYER: "SLEEP_UNITY_PLAYER",
	CLOSE_UNITY_PLAYER: "CLOSE_UNITY_PLAYER",
	WIP_UPDATE_USER_PROPERTY: "WIP_UPDATE_USER_PROPERTY",
	OPEN_CREATE_SPACE: "OPEN_CREATE_SPACE",
	UPDATE_CREATE_SPACE: "UPDATE_CREATE_SPACE",
	CHANGE_FIND_GROUP_SPACE_SIZE: "CHANGE_FIND_GROUP_SPACE_SIZE",
	OPEN_INVITE_MEMBER_PANEL: "OPEN_INVITE_MEMBER_PANEL",
	UPDATE_CHAT_DETAIL_INFO: "UPDATE_CHAT_DETAIL_INFO",
	SIDEBAR_COMMAND: "SIDEBAR_COMMAND",
	SOUND_COMMAND: "SOUND_COMMAND",
	OPEN_GROUP_PANEL: "OPEN_GROUP_PANEL",
	OPEN_SPACE_PANEL: "OPEN_SPACE_PANEL",
	OPEN_MY_ROOM_PANEL: "OPEN_MY_ROOM_PANEL",
	OPEN_ADD_USER_PANEL: "OPEN_ADD_USER_PANEL",
	OPEN_GROUP_SETTING: "OPEN_GROUP_SETTING",
	OPEN_SPACE_SETTING: "OPEN_SPACE_SETTING",
	OPEN_MY_SPACE_SETTING: "OPEN_MY_SPACE_SETTING",
	OPEN_INVITE_SPACE_MEMBER: "OPEN_INVITE_SPACE_MEMBER",
	OPEN_MANAGE_SPACE_MEMBER: "OPEN_MANAGE_SPACE_MEMBER",
	OPEN_PEOPLEDETAIL_PANEL: "OPEN_PEOPLEDETAIL_PANEL",
	OPEN_PEOPLE_PANEL: "OPEN_PEOPLE_PANEL",
	OPEN_USER_EDITOR: "OPEN_USER_EDITOR",
	OPEN_MEETING_INFO: "OPEN_MEETING_INFO",
	OPEN_MINI_PROFILE: "OPEN_MINI_PROFILE",
	CLOSE_MINI_PROFILE: "CLOSE_MINI_PROFILE",
	OPEN_PHONE_DETAIL: "OPEN_PHONE_DETAIL",
	onUnityMessage: "ON_UNITY_MESSAGE",
	onUnityRenderTexture: "ON_UNITY_RENDERTEXTURE",
	onTabHidden: "ON_TAB_HIDDEN",
	onBlur: "ON_BLUR",
	onAway: "ON_AWAY",
	onPopoverChanged: "ON_POPOVER_CHANGED",
	onChatCommand: "ON_CHAT_COMMAND",
	onGroupCommand: "ON_GROUP_COMMAND",
	onSpaceCommand: "ON_SPACE_COMMAND",
	onEnterRoom: "ON_ENTER_ROOM",
	onExitRoom: "ON_EXIT_ROOM",
	onChangeRoom: "ON_CHANGE_ROOM",
	onDeleteRoom: "ON_DELETE_ROOM",
	onMeetingCommand: "ON_MEETING_COMMAND",
	UPDATE_FILE_NAME: "UPDATE_FILE_NAME",
	REPLY_CHAT: "REPLY_CHAT",
	UPDATE_CHANNEL_NAME: "UPDATE_CHANNEL_NAME",
	DROP_CHAT_FILES: "DROP_CHAT_FILES",
	NOTIFICATION_FIRED: "NOTIFICATION_FIRED",
	CHANGE_FULL_SIZE_CHAT_TAB: "CHANGE_FULL_SIZE_CHAT_TAB",
	STOP_VOICECHAT_BY_PRIORITY: "STOP_VOICECHAT_BY_PRIORITY",
	OPEN_PAST_MEETING: "OPEN_PAST_MEETING",
	OPEN_PENDING_MEETING: "OPEN_PENDING_MEETING",
	OPEN_CREATE_SCHEDULE_MEETING: "OPEN_CREATE_SCHEDULE_MEETING",
	OPEN_CONFIRM_MEETING_RESERVATION: "OPEN_CONFIRM_MEETING_RESERVATION",
	OPEN_CONFERENCE_SETTING: "OPEN_CONFERENCE_SETTING",
	OPEN_MEETING_DETAIL: "OPEN_MEETING_DETAIL",
	OPEN_UPDATE_MESSAGE: "OPEN_UPDATE_MESSAGE",
	OPEN_EDIT_MEETING: "OPEN_EDIT_MEETING",
	OPEN_CONFERENCE_START: "OPEN_CONFERENCE_START",
	UPDATE_EMERGENCY: "UPDATE_EMERGENCY",
	ON_MEETING_EDITED: "ON_MEETING_EDITED",
	OPEN_VIEW_GROUP_SPACES: "OPEN_VIEW_GROUP_SPACES",
	CHANGE_VIEW_GROUP_SPACES_SIZE: "CHANGE_VIEW_GROUP_SPACES_SIZE",
	OPEN_SEARCH_RESULT_ON_MINI_CHAT: "OPEN_SEARCH_RESULT_ON_MINI_CHAT",
	TOGGLE_OPEN_SEARCH_ON_CONVERSATION_INPUT: "TOGGLE_OPEN_SEARCH_ON_CONVERSATION_INPUT",
	SEARCH_CHAT: "SEARCH_CHAT"
} as const;
export type EventID = (typeof EventID)[keyof typeof EventID];
